import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ISection, IDocumentType, ISeoDocument } from '../../../../core/models/documents.model';

@Component({
    selector: 'app-blogs',
    imports: [RouterLink],
    templateUrl: './blogs.html',
    styleUrl: './blogs.scss',
})
export class Blogs {
    sectionsRows = input.required<ISection[][]>();
    children = input.required<IDocumentType[]>();

    getTitle(child: IDocumentType): string {
        if (!child) return '';
        const nameVal = child.name as unknown;
        if (nameVal && typeof nameVal === 'object' && !Array.isArray(nameVal)) {
            const nameObj = nameVal as Record<string, string>;
            if ('en' in nameObj) return nameObj['en'];
            const vals = Object.values(nameObj);
            if (vals.length > 0) return vals[0];
        } else if (typeof child.name === 'string') {
            return child.name;
        } else if (Array.isArray(child.name) && child.name.length > 0) {
            return child.name[0];
        }
        const seo = this.getSeoDoc(child);
        return seo?.meta_title || 'Untitled Blog';
    }

    getFeaturedImage(child: IDocumentType): string {
        const seo = this.getSeoDoc(child);
        if (seo?.featured_image) {
            return seo.featured_image;
        }
        return 'assets/imgs/logo.png';
    }

    getDescription(child: IDocumentType): string {
        const seo = this.getSeoDoc(child);
        if (seo?.meta_description) {
            return seo.meta_description;
        }
        return 'Explore comprehensive guides, legal updates, and professional document authentication insights.';
    }

    getDate(child: IDocumentType): string {
        const dateStr = child?.created_at || child?.updated_at;
        if (!dateStr) return '';
        try {
            const date = new Date(dateStr);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
            });
        } catch {
            return '';
        }
    }

    getRouterLink(child: IDocumentType): string[] {
        if (!child?.slug) return ['/'];
        return ['/', ...child.slug.split('_')];
    }

    getCleanContent(content: string): string {
        if (!content) return '';
        return content.replace(/\$\w+/g, '').trim();
    }

    private getSeoDoc(child: IDocumentType): ISeoDocument | null {
        if (!child?.SeoDocument) return null;
        if (Array.isArray(child.SeoDocument)) {
            return child.SeoDocument[0] || null;
        }
        return (child.SeoDocument as ISeoDocument) || null;
    }
}

